import React from "react";
import formateText from "../../../../utils/Formate";
import { BsFillBoxFill } from "react-icons/bs";

const AdminBookingCard = ({ name, value }) => {
  return (
    <div className="w-full rounded-2xl border border-stone-200 bg-white p-5 shadow-sm">
      <div className="flex w-full justify-between items-start gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-stone-500">
            {formateText(name)}
          </p>
          <p className="text-4xl mt-2 font-semibold tabular-nums text-stone-900">
            {value}
          </p>
        </div>
        <span className="h-10 w-10 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center">
          <BsFillBoxFill className="text-lg" />
        </span>
      </div>
    </div>
  );
};

export default AdminBookingCard;
